<template>
    <div class="w-full h-screen flex items-center justify-center">
        <div class="max-w-lg px-4">
<!--            <h1 class="text-4xl md:text-6xl">{{T('about')}}</h1>-->
            <div v-html="$store.state.posts.about.body[locale()]"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'about',
        props: {

        },
        data(){
            return{

            }
        },
        mounted() {

        }
    }
</script>
